import styles from './index.module.scss'

const Loader = () => {
    return (
        <div className={styles['lds-ellipsis']}><div></div><div></div><div></div><div></div></div>
    )
}

export default Loader;